import { ReactComponent as TurnArrowIcon } from './turn_arrow.svg';

export default TurnArrowIcon;
